import React from "react";
import { Cars } from "./Cars/Cars";
import {
  MAP_GLOBAL_STATES,
  FLEET_GLOBAL_STATES,
} from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import { Settings } from "./Settings/index";
import { Scorecards } from "./Scorecards";
import UsageReport from "./Usage";
import { useEffect } from "react";
export const Fleet = () => {
  const {
    selectedCarList2,
    selectedCarListBackup,
    toggleSelectedCars,
    toggleUnselectedCars,
  } = useHookstate(FLEET_GLOBAL_STATES);

  const { mapSideNavTabState } = useHookstate(MAP_GLOBAL_STATES);

  useEffect(() => {
    let getSubnavName = localStorage.getItem("mapSideNavTabState");
    if (
      getSubnavName === "Usage" ||
      getSubnavName === "Cars" ||
      getSubnavName === "Scorecards" ||
      getSubnavName === "Settings"
    ) {
      mapSideNavTabState.set(localStorage.getItem("mapSideNavTabState"));
    } else {
      mapSideNavTabState.set("Cars");
      localStorage.setItem("mapSideNavTabState", "Cars");
    }
  }, []);

  useEffect(() => {
    if (selectedCarList2.get().length === selectedCarListBackup.get().length) {
      toggleSelectedCars.set(true);
    } else if (
      selectedCarList2.get().length !== selectedCarListBackup.get().length
    ) {
      toggleSelectedCars.set(false);
    } else if (selectedCarList2.get().length === 0) {
      toggleUnselectedCars.set(true);
    }
  }, [selectedCarList2.get()]);

  switch (mapSideNavTabState.get()) {
    case "Cars":
      return <Cars />;
    case "Usage":
      return <UsageReport />;
    case "Scorecards":
      return <Scorecards />;
    case "Settings":
      return <Settings />;
  }
};
